export { BonusIcon } from './BonusIcon';
